/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "@redux-devtools/extension";
import * as sagas from "./rootSaga";
import reducer from "./rootReducer";

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);
sagas.registerWithMiddleware(sagaMiddleware);

// refer https://decembersoft.com/posts/4-tips-for-managing-many-sagas-in-a-react-redux-saga-app/
// for 'sagas.registerWithMiddleware' pattern
